interface Endpoint {
  devClientId: string;
  devEndpointUserPoolId: string;
  appDomain: string;
}

export const alphaEndpoint: Endpoint = {
  devClientId: '21kb3b7itlcgd5ga2j2r4gt8vf',
  devEndpointUserPoolId: 'us-east-1_Gn1UV6Xsz',
  appDomain: 'alpha-conferencemanager.auth.us-east-1.amazoncognito.com',
};

export const integEndpoint: Endpoint = {
  devClientId: '3pv4m490r20gu9nlvnpeiejlgc',
  devEndpointUserPoolId: 'us-east-1_iyaorLvrO',
  appDomain: 'integ-conferencemanager.auth.us-east-1.amazoncognito.com',
};

export const gammaEndpoint: Endpoint = {
  devClientId: '4jburu6slnreds80g8v6hbrj0l',
  devEndpointUserPoolId: 'us-east-1_1WvjVqgky',
  appDomain: 'gamma-conferencemanager.auth.us-east-1.amazoncognito.com',
};
